<template>
  <RevContainer class="py-6 text-center">
    <Error4xx v-if="is4XX" :error />
    <Error500 v-if="!is4XX" :error />
  </RevContainer>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { computed } from 'vue'

import Error4xx from '@backmarket/nuxt-layer-base/components/Error4xx/Error4xx.vue'
import Error500 from '@backmarket/nuxt-layer-base/components/Error500/Error500.vue'
import { RevContainer } from '@ds/components/Container'

const props = defineProps<{ error: NuxtError }>()

const is4XX = computed(() => [404, 410, 422].includes(props.error.statusCode))
</script>
